export function getRiskScoreColor(value?: number, medium = 33, high = 67) {
    if (!value) return 'gray'
    if (value <= medium) return 'green'
    if (value <= high) return 'orange'
    return 'red'
}
